import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/RootReducer';
import { ActionStatus } from 'store/ActionState';
import { MsEntraID } from 'gql/MsEntraID';
import { MsEntraIDState, msEntraIDAdapter } from './MsEntraIDSlice';

const selectSelf = (state: RootState): MsEntraIDState => {
  return state.msEntraID;
};

const selectMsEntraIDLoading = createSelector(selectSelf, (state: MsEntraIDState): boolean => {
  return state.loadingState.status === ActionStatus.PROCESSING;
});

const selectMsEntraIDs = createSelector(selectSelf, (state: MsEntraIDState): MsEntraID[] => {
  return msEntraIDAdapter.getSelectors().selectAll(state.msEntraIDs);
});

const selectMsEntraID = (id?: string) => {
  return (state: RootState): MsEntraID | undefined => {
    return id ? state.msEntraID.msEntraID : undefined;
  };
};

const selectMutationSucceeded = createSelector(selectSelf, (state: MsEntraIDState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

// CREATE
const selectCreateProcessing = createSelector(selectSelf, (state: MsEntraIDState): boolean => {
  return state.mutationState.status === ActionStatus.PROCESSING;
});

const selectCreateMsEntraIDId = createSelector(selectSelf, (state: MsEntraIDState): string | undefined => {
  return state.mutatedMsEntraIDId;
});

const selectCreateSucceeded = createSelector(selectSelf, (state: MsEntraIDState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

// UPDATE
const selectUpdateProcessing = createSelector(selectSelf, (state: MsEntraIDState): boolean => {
  return state.mutationState.status === ActionStatus.PROCESSING;
});

const selectUpdateSucceeded = createSelector(selectSelf, (state: MsEntraIDState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

const selectUpdateMSEntraIDId = createSelector(selectSelf, (state: MsEntraIDState): string | undefined => {
  return state.mutatedMsEntraIDId;
});

const MsEntraIDSelectors = {
  selectMutationSucceeded,
  selectMsEntraIDLoading,
  selectMsEntraIDs,
  selectMsEntraID,
  selectCreateProcessing,
  selectCreateMsEntraIDId,
  selectCreateSucceeded,
  selectUpdateProcessing,
  selectUpdateSucceeded,
  selectUpdateMSEntraIDId,
};

export default MsEntraIDSelectors;
